import { useEffect } from 'react';
import { useHistory, useLocation } from '@react-router';
import type { Location } from 'history';
import { invokeFnOnceFactory } from '@shared/utils/invokeFnOnceFactory';
import { activeFiltersVar } from '../../../Catalog.cache';
import { deriveActiveFiltersFromUrl } from '../RefinementsPanel.utils';

const initializeFilters = invokeFnOnceFactory();

const syncFiltersFromLocation = (location: Location) => {
  const composedUrl = `${location.pathname}${location.search}${location.hash}`;
  activeFiltersVar(deriveActiveFiltersFromUrl(composedUrl));
};

/**
 * This hook will keep the reactive `activeFilters` var in sync with the URL.
 * The URL serves as the source of truth for determining active filters.
 */
export const useUrlSyncedFilters = () => {
  const history = useHistory();
  const location = useLocation();

  initializeFilters(() => {
    syncFiltersFromLocation(location);
  });

  useEffect(() => {
    const unregister = history.listen((loc, action) => {
      syncFiltersFromLocation(loc);
    });

    return () => {
      unregister();
    };
  }, [history]);
};
